export function CaretIcon({ height = '24px', rotate, color = 'black' }: { height?: string; rotate?: string; color?: string }) {
  return (
    <svg height={height} viewBox="0 0 14 24" style={{ transform: rotate ? `rotate(${rotate})` : 'initial' }} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.761892 11.144C0.295515 11.6104 0.295515 12.3896 0.761892 12.8572L11.5229 23.6457C11.9952 24.1181 12.7612 24.1181 13.2324 23.6457C13.7048 23.1734 13.7048 22.4061 13.2324 21.9338L3.32627 12L13.2336 2.06751C13.706 1.59395 13.706 0.827919 13.2336 0.354366C12.7612 -0.11799 11.9952 -0.11799 11.524 0.354366L0.761892 11.144Z" fill={color}/>
    </svg>
  )
}
